import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['copiedText', 'groupLinkUrl', 'effectivenessReviewLinkUrl'];

  connect() {
    this.timeoutId = null;
  }

  copyUrl(event) {
    this.hideSuccessMessage();

    const { url } = event.currentTarget.dataset;

    navigator.clipboard.writeText(url);
    this.copiedTextTarget.hidden = false;

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.hideSuccessMessage(), 5000);
  }

  hideSuccessMessage() {
    this.copiedTextTarget.hidden = true;
  }
}
